/**
 * Colour prefetch — merchant, 2026-10-20: "the images of products should load
 * faster without compromising on quality".
 *
 * Picking a colour re-renders the gallery with that colour's photographs
 * (main-product.liquid, the per-colour gallery), and only THEN does the
 * browser discover the new main image and start downloading it. On a phone
 * that is a round trip for the section followed by another for a ~130KB
 * photo, in series.
 *
 * This starts the photo the moment intent shows — a finger landing on the
 * colour (pointerdown comes before the click that changes the variant), a
 * pointer resting on it, or keyboard focus — so the two downloads run side by
 * side and the new gallery usually finds its image already in cache.
 *
 * WHY THE SWATCH: each photo option already shows that colour's FRONT photo
 * (at 160px), and the colour's gallery opens on the same file. So the URL is
 * on the page; only the width differs. The request goes through an unattached
 * <img> carrying the gallery's own `sizes` and the same width list
 * product-thumbnail.liquid gives `image_tag`, so the browser picks the very
 * candidate the gallery will ask for and the cache key matches. Quality is
 * untouched: it is the same file at the same width the page would load anyway.
 *
 * Standalone and passive: no element of the variant picker or the gallery is
 * touched, so nothing here can stall a variant change (see the note on silent
 * throws in the variant flow). Once per colour per page.
 */
(function () {
  var WIDTHS = [493, 713, 990, 1206, 1426];
  var warmed = {};

  function warm(label) {
    var img = label && label.querySelector('.product-photo-option__media img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src || warmed[src]) return;
    warmed[src] = true;

    var base = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    var join = base.indexOf('?') === -1 ? '?' : '&';
    var galleryImg = document.querySelector('media-gallery .product__media img');

    var pre = new Image();
    pre.decoding = 'async';
    // sizes BEFORE srcset: setting srcset is what starts selection
    if (galleryImg && galleryImg.sizes) pre.sizes = galleryImg.sizes;
    pre.srcset = WIDTHS.map(function (w) {
      return base + join + 'width=' + w + ' ' + w + 'w';
    }).join(', ');
  }

  function onIntent(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var label = target.closest('.product-photo-option');
    if (label) warm(label);
  }

  document.addEventListener('pointerdown', onIntent, { passive: true });
  document.addEventListener('mouseover', onIntent, { passive: true });
  document.addEventListener('focusin', function (event) {
    var input = event.target && event.target.closest && event.target.closest('.product-photo-option__input');
    if (!input || !input.id) return;
    var label = document.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
    if (label) warm(label);
  });
})();
